export default "__VITE_ASSET__C9VJzTjy__"